import PropTypes from "prop-types";
import React from "react";
import { getCustomerLoyaltyPointsQuery } from "rsl-api-106/lib/queries";
import {
  Query,
  QueryGetCustomerLoyaltyPointsArgs,
  Service,
} from "rsl-api-106/lib/types";

import { useQuery } from "@apollo/client";
import Disclosure from "@components/_Layout/Disclosure";
import CustomerDetails from "@components/Customer/CustomerDetails";
import {
  CustomerDetailsBox,
  CustomerPassword,
} from "@components/Customer/CustomerDetails/CustomerDetails";
import { useAuth, useConfig, useSession } from "@hooks";
import { getAbsoluteImagePath } from "@utils/dom";

type CustomerInfosAreaProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_mes", //Mes
  "LANG_neobooking_mon", //Mon
  "LANG_neobooking_area_personnal_information", //informations personnelles
  "LANG_neobooking_area_fidelity_program", //programme fidélité
  "LANG_neobooking_area_fidelity_tribu_member", //Membre de la tribu Vacancéole
  "LANG_neobooking_area_fidelity_left_you", //Il vous reste
  "LANG_neobooking_area_fidelity_to_unlock_reward", //pour débloquer votre récompense de
  "LANG_neobooking_area_fidelity_reward_value", //20€
  "LANG_neobooking_area_fidelity_spend_over_600", //dépensés sur 600€
];

const CustomerInfosArea: React.FC<CustomerInfosAreaProps> = () => {
  /* Hooks */
  const { user } = useAuth();
  const { getLanguageVarValue, authMode } = useSession();

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <Disclosure
        variant="transparent"
        showFleche
        defaultOpen={authMode === 2}
        title={
          <span>
            {getLanguageVarValue("LANG_neobooking_mes")}{" "}
            {getLanguageVarValue("LANG_neobooking_personnal_information")}
          </span>
        }
        titleOpen={
          <span>
            {getLanguageVarValue("LANG_neobooking_mes")}{" "}
            <span className="tw-underline tw-underline-offset-[6px]">
              {getLanguageVarValue("LANG_neobooking_personnal_information")}
            </span>
          </span>
        }
      >
        {authMode === 2 ? (
          <div>
            <CustomerDetailsBox user={user} />
            <CustomerPassword />
          </div>
        ) : (
          <CustomerDetails user={user} showDeleteAccount={false} />
        )}
      </Disclosure>
      {authMode !== 2 ? (
        <Disclosure
          variant="transparent"
          showFleche
          title={
            <span>
              {getLanguageVarValue("LANG_neobooking_mon")}{" "}
              {getLanguageVarValue("LANG_neobooking_fidelity_program")}
            </span>
          }
          titleOpen={
            <span>
              {getLanguageVarValue("LANG_neobooking_mon")}{" "}
              <span className="tw-underline tw-underline-offset-[6px]">
                {getLanguageVarValue("LANG_neobooking_fidelity_program")}
              </span>
            </span>
          }
        >
          <FidelityProg user={user!!} />
        </Disclosure>
      ) : (
        <></>
      )}
    </div>
  );
};

type FidelityProgProps = {
  user: Service;
};
const FidelityProg: React.FC<FidelityProgProps> = ({ user }) => {
  /* Hooks */
  const { sessionId, getLanguageVarValue } = useSession();
  const { mode: clientMode } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";

  /* States */
  const limit = 600;

  const { data } = useQuery<Query, QueryGetCustomerLoyaltyPointsArgs>(
    getCustomerLoyaltyPointsQuery(),
    {
      variables: {
        session: { name: sessionId },
      },
      fetchPolicy: "cache-and-network",
      //fetchPolicy: "no-cache",
    }
  );

  return (
    <>
      <div className="tw-flex tw-gap-2 tw-my-2">
        <img
          className="!tw-w-[55px] !tw-h-[55px]"
          src={getAbsoluteImagePath("/assets/img/icons/user.svg")}
        ></img>
        <div className="tw-flex tw-flex-col">
          <div className="tw-text-2xl tw-font-bold">
            {user?.firstName} {user?.lastName}
          </div>
          <div className="tw-text-sm tw-font-medium">
            {getLanguageVarValue("LANG_neobooking_area_fidelity_tribu_member")}
          </div>
        </div>
      </div>
      <div>
        <div className="tw-mb-4">
          {getLanguageVarValue("LANG_neobooking_area_fidelity_left_you")}{" "}
          <span className="tw-font-bold">
            {600 - (data?.getCustomerLoyaltyPoints?.points ?? 0)}
          </span>{" "}
          {getLanguageVarValue(
            "LANG_neobooking_area_fidelity_to_unlock_reward"
          )}{" "}
          <span className="tw-font-bold">
            {getLanguageVarValue("LANG_neobooking_area_fidelity_reward_value")}
          </span>
        </div>
        <div>
          <div className="tw-h-8 tw-border tw-border-black">
            <div
              className={`${
                mode === "vacanceole"
                  ? "tw-bg-primary-500"
                  : "tw-bg_corseole-secondary"
              } tw-h-full`}
              style={{
                width: `${
                  ((data?.getCustomerLoyaltyPoints?.points ?? 0) * 100) / limit
                }%`,
              }}
            ></div>
          </div>
          <div className="tw-text-center">
            {data?.getCustomerLoyaltyPoints?.points ?? 0}{" "}
            {getLanguageVarValue(
              "LANG_neobooking_area_fidelity_spend_over_600"
            )}
          </div>
        </div>
      </div>
    </>
  );
};

CustomerInfosArea.propTypes = {
  //
};

export default CustomerInfosArea;
